// !!! variables can not be the same, here and all over !!!

export const State = {
  stockDetail: null
}

export const Mutations = {
  saveStockDetail(state, detail) {
    state.stockDetail = detail
  }
}

export const Actions = {
  saveStockDetail({ commit }, detail) {
    sessionStorage.setItem('stockDetail', JSON.stringify(detail))
  },
  getStockDetail({ commit }) {
    const stockDetail = JSON.parse(sessionStorage.getItem('stockDetail'))
    commit('saveStockDetail', stockDetail)
    return stockDetail
  }
}
